<div class="login-page">
  <div class="panel">
    <img src="/assets/images/smart-lga-logo.png" class="smart-lga-logo" alt="" />

    <form class="wrapper" [formGroup]="createPasswordForm">
      <h6 style="
            color: #074a97;
            text-decoration: underline;
            text-align: center;
            font-weight: 800;
            font-size: 24px;
          ">
        Create New Password
      </h6>

      <div class="field">
        <label for="">New Password</label>
        <div class="password-input" style="position: relative">
          <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password"
            placeholder="************" [maxlength]="50" />
          <span class="material-symbols-outlined" style="
                position: absolute;
                right: 10px;
                bottom: 7px;
                cursor: pointer;
              " (click)="toggleShowPassword()">
            {{ showPassword ? "visibility" : "visibility_off" }}
          </span>
        </div>
      </div>

      <div class="field">
        <label for="">Confirm Password</label>
        <div class="password-input" style="position: relative">
          <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="confirmPassword"
            placeholder="************" [maxlength]="50" />
          <span class="material-symbols-outlined" style="
                position: absolute;
                right: 10px;
                bottom: 7px;
                cursor: pointer;
              " (click)="toggleShowPassword()">
            {{ showPassword ? "visibility" : "visibility_off" }}
          </span>
        </div>
      </div>

      <span class="error-container" *ngIf="errorMessage">{{
        errorMessage
        }}</span>

      <ng-template #checked>
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.22656 12.3896C2.91276 12.3896 0.226562 9.70345 0.226562 6.38965C0.226562 3.07585 2.91276 0.389648 6.22656 0.389648C9.54036 0.389648 12.2266 3.07585 12.2266 6.38965C12.2266 9.70345 9.54036 12.3896 6.22656 12.3896ZM5.62836 8.78965L9.87036 4.54705L9.02196 3.69865L5.62836 7.09285L3.93096 5.39545L3.08256 6.24385L5.62836 8.78965Z"
            fill="#0E8056" />
        </svg>
      </ng-template>


      <ng-template #unChecked>
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.22656 12.3896C2.91276 12.3896 0.226562 9.70345 0.226562 6.38965C0.226562 3.07585 2.91276 0.389648 6.22656 0.389648C9.54036 0.389648 12.2266 3.07585 12.2266 6.38965C12.2266 9.70345 9.54036 12.3896 6.22656 12.3896ZM6.22656 5.54125L4.52976 3.84385L3.68076 4.69285L5.37816 6.38965L3.68076 8.08645L4.52976 8.93545L6.22656 7.23805L7.92336 8.93545L8.77236 8.08645L7.07496 6.38965L8.77236 4.69285L7.92336 3.84385L6.22656 5.54125Z"
            fill="#868C98" />
        </svg>
      </ng-template>

      <div class="password-strength">
        <span [class.active]="passwordStrength >= 1"></span>
        <span [class.active]="passwordStrength >= 2"></span>
        <span [class.active]="passwordStrength >= 3"></span>
        <span [class.active]="passwordStrength >= 4"></span>
      </div>

      <div class="validation-wrapper">
        <p>
          <ng-container *ngTemplateOutlet="createPasswordForm?.errors?.hasUppercase ? unChecked : checked"></ng-container>
          At least 1 uppercase
        </p>
        <p>
          <ng-container *ngTemplateOutlet="createPasswordForm?.errors?.hasNumber ? unChecked : checked"></ng-container>
          At least 1 number
        </p>
        <p>
          <ng-container *ngTemplateOutlet="createPasswordForm?.errors?.minLength8 ? unChecked : checked"></ng-container>
          Minimum 8 characters
        </p>
        <p>
          <ng-container *ngTemplateOutlet="createPasswordForm?.errors?.passwordsMismatch ? unChecked : checked"></ng-container>
          Passwords must match
        </p>
      </div>

      <div class="countdown-wrapper">
        <div class="clock-container">
          <svg viewBox="0 0 100 100" class="clock">

            <circle cx="50" cy="50" r="45" class="clock-face"></circle>

            <path [attr.d]="getUsedArc()" stroke="red" stroke-width="5" fill="none"></path>

            <path [attr.d]="getRemainingArc()" stroke="green" stroke-width="5" fill="none"></path>

            <circle cx="50" cy="50" r="3" class="clock-center"></circle>


            <line
              x1="50"
              y1="50"
              x2="50"
              y2="12"
              class="clock-hand"
              [style.transform]="'rotate(' + rotationAngle + 'deg)'"
              [style.transformOrigin]="'50% 50%'">
            </line>
          </svg>
        </div>

        <div class="expiry-text">
          Expires at <strong>{{ expiryTime }}</strong> ({{ remainingTime }} remaining)
        </div>
      </div>



      <button class="btn-deep-blue w-100"
        [disabled]="createPasswordForm.invalid || createPasswordForm.pristine || passwordCreationInProgress"
        (click)="openConfirmModal()">
        Create Password
        <div class="spinner-light" *ngIf="passwordCreationInProgress"></div>
      </button>
    </form>
  </div>
</div>
